import { Layout } from '@/components';
import DeleteAccountIcon from '@/assets/svg/delete-account.svg';
import '@/assets/styles/views/delete-account/delete-account.scss';

const DeleteAccountScreen = () => {
	return (
		<Layout>
			<div className="delete-account-container">
				<img
					src={DeleteAccountIcon}
					alt="Delete Account"
					className="delete-img"
				/>
				<div className="title">Üyelik İptal Süreci</div>
				<p className="description">
					Hesabınızı kapatmadan önce, size en iyi hizmeti sunabilmemiz için herhangi bir sorunuz veya endişeniz varsa, lütfen bizimle iletişime geçmekte tereddüt etmeyin. Müşteri hizmetleri
					ekibimiz, her türlü sorunuzu çözmek ve size yardımcı olmak için burada.
				</p>
				<p className="description">Yine de hesabınızı kapatmak veya herhangi bir diğer konuda destek almak istiyorsanız aşağıdaki mail adresinden bize ulaşabilirsiniz.</p>
				<a
					className="email-container"
					href="mailto:birebiruzman@dopinghafiza.com">
					birebiruzman@dopinghafiza.com
				</a>
			</div>
		</Layout>
	);
};

export default DeleteAccountScreen;
